export function initSidebar() {
  const hum = document.querySelectorAll('.hum'),
    sidebar = document.querySelector('.sidebar'),
    close = document.querySelector('.sidebar__close')

  if (!hum || !close) return

  hum.forEach( button => {
    button.addEventListener('click', () => {
      sidebar.classList.toggle('open')
      window.scrollTo({top: 0, behavior: 'smooth'})
    })
  })
  close.addEventListener('click', () => {
    sidebar.classList.remove('open')
  })
}
